import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "max-w-300 mt-x4 md:mt-x5" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 0,
  class: "mt-32"
}
const _hoisted_4 = { class: "mt-10 o-text-caption" }

import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import { computed, Ref } from 'vue';
import { LinkModel } from '@/types/B2CcontentServerContract';
import siteContextService from '@/b2c/shared/site-context.service';
import useSpecialDeliveryRequest from '@/shared/product/details/useSpecialDeliveryRequest';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductPurchaseRequestDelivery',
  setup(__props) {

const labels = useBlockLabels();
const { requestSpecialDelivery } = useSpecialDeliveryRequest();

const findStoresLink: Ref<LinkModel> = computed(() => {
    return siteContextService.findStoresLink ?? {} as LinkModel;
});


return (_ctx: any,_cache: any) => {
  const _component_RouterLinkConditional = _resolveComponent("RouterLinkConditional")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createVNode(_component_RouterLinkConditional, {
      class: "c-button c-button--basket min-w-220 w-auto",
      to: _unref(findStoresLink).url,
      "spa-enabled": _unref(findStoresLink).spaLink
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(labels).findStoreAndDealersTitle), 1)
      ]),
      _: 1
    }, 8, ["to", "spa-enabled"]),
    _createElementVNode("div", {
      class: "magic-line-on-child-links text-dusty-grey-on-child-links mt-8",
      innerHTML: _unref(labels).findStoreAndDealersDescription
    }, null, 8, _hoisted_2),
    (_unref(requestSpecialDelivery) && _unref(requestSpecialDelivery).url)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_RouterLinkConditional, {
            class: "c-button min-w-220 w-auto",
            to: _unref(requestSpecialDelivery).url,
            "spa-enabled": _unref(requestSpecialDelivery).spaLink
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(labels).specialDeliveryPurchaseTitle), 1)
            ]),
            _: 1
          }, 8, ["to", "spa-enabled"]),
          _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(labels).specialDeliveryPurchaseDescription), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})